import type { JiraFieldData } from '../../../../../../controllers/request-create-context-provider/types';

export const getSchemaKey = (
	jiraFieldKey: string | undefined,
	jiraFieldData: JiraFieldData,
): string | undefined => {
	if (!jiraFieldKey) {
		return undefined;
	}
	const fieldData = jiraFieldData.get(jiraFieldKey);
	return fieldData?.schema?.system ?? fieldData?.schema?.custom;
};
